module.exports = __webpack_public_path__ + "static/media/breadcrumb-arrow.cd6ac044.svg";